import { computed, ref, watch, onBeforeUnmount } from 'vue'
import { getCompanyLogo } from '@/modules/auth/api/company-logo.service'
import { usePermissionsStore } from '@/modules/auth/store/permissions.store'

// Each consumer owns its blob URL. Ignore responses from previous users/versions.
export function useCompanyLogo(source) {
  const permissions = usePermissionsStore()
  const canUseCompanyLogo = computed(() => permissions.hasPermission('ManageCompanyLogo'))
  const activeSource = () => canUseCompanyLogo.value ? source() : ''
  const logoUrl = ref('')
  const logoLoading = ref(false)
  const logoError = ref('')
  let generation = 0
  function clear() {
    if (logoUrl.value) URL.revokeObjectURL(logoUrl.value)
    logoUrl.value = ''
  }
  async function reload() {
    const current = ++generation
    clear()
    logoError.value = ''
    logoLoading.value = false
    if (!activeSource()) return
    logoLoading.value = true
    try {
      const response = await getCompanyLogo()
      if (current === generation) logoUrl.value = URL.createObjectURL(response.data)
    } catch (error) {
      if (current !== generation) return
      const status = error.status ?? error.response?.status
      if (status === 403) {
        // Revocation is an expected inactive-logo state, not a broken image.
        await permissions.fetchPermissions(true)
      } else if (status !== 404) {
        logoError.value = 'Не удалось загрузить логотип. Попробуйте ещё раз.'
      }
    } finally {
      if (current === generation) logoLoading.value = false
    }
  }
  watch(activeSource, reload, { immediate: true, flush: 'sync' })
  onBeforeUnmount(() => { generation++; clear() })
  return { logoUrl, logoLoading, logoError, reload, canUseCompanyLogo }
}
